import { GlobalRoles } from '../data-models/global-roles.model';
import { User } from '../data-models/user.model';

/**
 * Helper functions for role checking
 * @deprecated Use CustomClaims methods directly (e.g., user.customClaims?.hasGlobalRole())
 */
export class UserRoleHelper {
  /**
   * Check if user has specific global role
   * @deprecated Use user.customClaims?.hasGlobalRole() instead
   */
  static hasRole(user: User, role: GlobalRoles): boolean {
    if (!user.customClaims) return false;
    return user.customClaims.hasGlobalRole(role);
  }

  /**
   * Check if user has any of the specified roles
   * @deprecated Use user.customClaims?.hasAnyGlobalRole() instead
   */
  static hasAnyRole(user: User, roles: GlobalRoles[]): boolean {
    return roles.some(role => this.hasRole(user, role));
  }

  /**
   * Check if user has all specified roles
   * @deprecated Use user.customClaims?.hasAllGlobalRoles() instead
   */
  static hasAllRoles(user: User, roles: GlobalRoles[]): boolean {
    return roles.every(role => this.hasRole(user, role));
  }

  /**
   * Check if user has specific permission
   * @deprecated Permissions are not implemented in current CustomClaims structure
   */
  static hasPermission(user: User, permission: string): boolean {
    return false;
  }

  /**
   * Get all roles for user
   * @deprecated Use user.customClaims?.getGlobalRoles() instead
   */
  static getUserRoles(user: User): GlobalRoles[] {
    return user.customClaims?.getGlobalRoles() ?? [];
  }
}
